<template>
  <span class="rf-icon" aria-hidden="true">
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
      <path
        fill="inherit"
        stroke="none"
        d="M12.48 5.158a.81.81 0 0 0-.96 0L7.199 8.584c-.265.21-.265.552 0 .762a.81.81 0 0 0 .96 0l3.162-2.508v11.624c0 .297.304.538.679.538.375 0 .679-.241.679-.538V6.838l3.162 2.508a.81.81 0 0 0 .96 0c.265-.21.265-.551 0-.762l-4.32-3.426Z"
      />
    </svg>
  </span>
</template>
